import {
  useAdminCredentials,
  useRevealCredential,
  useUpdateCredentials,
} from '../../../features/admin/use-admin-credentials'
import { VENDOR_KEYS, vendorBlock } from '../../../features/admin/vendors'
import { AdminPage, VendorCard } from './admin-bits'

export function PorcelainAdminCredentials() {
  const creds = useAdminCredentials()
  const update = useUpdateCredentials()
  const reveal = useRevealCredential()
  return (
    <AdminPage
      title="Credentials"
      subtitle="Vendor integration settings. Secrets stay masked until revealed, then hide again after 30 seconds."
      loading={creds.isLoading}
      error={!!creds.error}
    >
      {VENDOR_KEYS.map((v) => (
        <VendorCard
          key={v}
          vendor={v}
          block={vendorBlock(creds.data, v)}
          pending={update.isPending && update.variables?.vendor === v}
          error={update.variables?.vendor === v ? update.error : null}
          onSave={(body) => update.mutate(body)}
          reveal={(vendor, field) => reveal.mutateAsync({ vendor, field })}
        />
      ))}
    </AdminPage>
  )
}
